var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-graphs-section"},[_c('most-occurring-report',{ref:"occurring",attrs:{"error":_vm.occurring.error,"graphData":_vm.occurring.data,"wrapperWidth":_vm.occurring.width},on:{"loadGraphData":_vm.loadGraphData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }